import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram, faDiscord, faXTwitter } from "@fortawesome/free-brands-svg-icons";

const Sidebar = ({ isExpanded, toggleSidebar, zIndex = "z-50" }) => {


  return (
    <div
      className={`swap-card fixed top-5 left-5 transition-all duration-200 ${zIndex} ${
        isExpanded
          ? "w-72 max-h-[90vh] flex flex-col p-4 overflow-visible bg-gray-900 rounded-lg shadow-lg"
          : "w-36 h-16 flex items-center justify-between px-2 bg-gray-900 rounded-lg shadow-md"
      }`}
    >
      <div className="flex items-center justify-between w-full">
        <img
          src="https://github.com/divechan/brandkit/blob/main/SVGs/new-logos/testnet.png?raw=true"
          alt="Logo"
          className="w-12 h-12 rounded-lg"
        />
        <button
          className="w-10 h-10 ml-auto rounded-md"
          onClick={toggleSidebar}
        >
          <div className="relative w-6 h-1">
            <span
              className={`absolute w-6 h-0.5 bg-white transform transition-all duration-300 ${
                isExpanded ? "rotate-45 -translate-x-3 -translate-y-1" : "-translate-y-2"
              }`}
            ></span>
            <span
              className={`absolute w-6 h-0.5 bg-white transition-all duration-300 ${
                isExpanded ? "opacity-0" : "opacity-100"
              }`}
            ></span>
            <span
              className={`absolute w-6 h-0.5 bg-white transform transition-all duration-300 ${
                isExpanded ? "-rotate-45 -translate-x-3 -translate-y-1" : "translate-y-2"
              }`}
            ></span>
          </div>
        </button>
      </div>

      {isExpanded && (
        <div className="flex flex-col mt-4 space-y-4">
          <ul className="space-y-2">
            {/* Depot */}
            <li>
              <a
                href="https://depot.steamexchange.io"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 text-white rounded-md hover:bg-gray-600"
              >
                Depot
              </a>
            </li>

            {/* DEX */}
            <li>
              <a
                href="https://swap.steamexchange.io"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 text-white rounded-md hover:bg-gray-600"
              >
                DEX
              </a>
            </li>

            {/* Docs */}
            <li>
              <a
                href="https://docs.steamexchange.io"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-4 py-2 text-white rounded-md hover:bg-gray-600"
              >
                Docs
              </a>
            </li>

            

          </ul>

          {/* Social Icons */}
          <div className="flex pb-6 mt-auto justify-evenly">
            <a
              href="https://t.me/SteamXchangeOfficial"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white transition-transform transform hover:text-blue-600 hover:scale-110"
            >
              <FontAwesomeIcon icon={faTelegram} className="text-2xl" />
            </a>
            <a
              href="https://x.com/Steam_Exchange"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white transition-transform transform hover:text-blue-600 hover:scale-110"
            >
              <FontAwesomeIcon icon={faXTwitter} className="text-2xl" />
            </a>
            <a
              href="https://discord.com/invite/qD4YqBaEN2"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white transition-transform transform hover:text-blue-600 hover:scale-110"
            >
              <FontAwesomeIcon icon={faDiscord} className="text-2xl" />
            </a>
          </div>

          {/* Footer */}
          <div className="mt-auto sidebar-footer">
            Made with <span className="text-red-500">&hearts;</span> by Steam Exchange
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
